import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as i}from"../../icon-registry.js";const p=i("liberia",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="#BF0A30" />
            <path
                d="M24 10.3177L0 10.3177L0 8.86319L24 8.86319V10.3177ZM24 7.40865L0 7.40865L0 5.9541L24 5.9541V7.40865Z"
                fill="white" />
            <path
                d="M0 4.5L8.83678 4.5V11.7725L0 11.7725L0 4.5Z"
                fill="#002868" />
            <path
                d="M24 19.0452L0 19.0452L0 17.5906L24 17.5906V19.0452ZM24 16.1361L0 16.1361L0 14.6816L24 14.6816V16.1361ZM24 13.227L0 13.227L0 11.7725L24 11.7725V13.227Z"
                fill="white" />
            <path
                d="M5.30754 8.39337L6.7469 7.46101H4.96809L4.41813 5.9541L3.86817 7.46101H2.08936L3.52872 8.39337L2.97876 9.90174L4.41813 8.96937L5.8575 9.90174L5.30754 8.39337Z"
                fill="white" />
        </svg>
    `),d=i("liberia_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_66574)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L45.6 0.5L45.6 24.5L0 24.5L0 0.5Z"
                    fill="#BF0A30" />
                <path
                    d="M45.6 9.2271L0 9.2271L0 7.04528L45.6 7.04528V9.2271ZM45.6 4.86346L0 4.86346L0 2.68164L45.6 2.68164V4.86346Z"
                    fill="white" />
                <path
                    d="M0 0.5L10.9091 0.5L10.9091 12.5L0 12.5L0 0.5Z"
                    fill="#002868" />
                <path
                    d="M45.6 22.3183L0 22.3183L0 20.1365L45.6 20.1365V22.3183ZM45.6 17.9546L0 17.9546L0 15.7728L45.6 15.7728V17.9546ZM45.6 13.591L0 13.591L0 11.4092L45.6 11.4092V13.591Z"
                    fill="white" />
                <path
                    d="M7.41973 7.19797L9.3441 5.79943L6.96591 5.79943L6.23064 3.53906L5.49537 5.79943H3.11719L5.04155 7.19797L4.30628 9.46052L6.23064 8.06197L8.15501 9.46052L7.41973 7.19797Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19470_66574">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Liberia,d as LiberiaRounded};
